import { createFileRoute } from '@tanstack/react-router';
import { PeopleListRouteView } from '@/pages/workspaces/people/routing';
import { LastWorkspaceResolver } from './-components';

/**
 * The People list page's search params. All of them are written and read by
 * `usePeopleListPage` (nuqs); declared here so typed `Link`s can build
 * filtered views and deep links survive validation.
 */
type PeopleListSearch = {
  /** Email search term (mutually exclusive with `filters` server-side). */
  email?: string;
  /** Base64-encoded condition filters. */
  filters?: string;
  /** 1-based page number. */
  page?: number;
  /** Analytics attribution for inbound links (e.g. `segment_people`); consumed after one load. */
  source?: string;
};

/**
 * No `appBundle`: this URL has no `journeys` segment, and the bundle-aware
 * branch of the resolver rebuilds the target from the bundle prefix — which
 * would find no `/journeys/` here and land on the Journeys home instead.
 */
function PeopleIndexRoute() {
  return (
    <LastWorkspaceResolver>
      <PeopleListRouteView />
    </LastWorkspaceResolver>
  );
}

export const Route = createFileRoute('/_authenticated/workspaces/$workspaceId/profiles/')({
  component: PeopleIndexRoute,
  // validateSearch replaces this route's search, so spread the incoming params
  // to preserve global ones the page doesn't own (masq_account_id, …) and only
  // narrow the ones it does.
  // oxlint-disable-next-line local-rules/no-unsafe-dictionary-type -- validateSearch is handed unparsed search input, and the pass-through carries those same unvalidated values
  validateSearch: (search: Record<string, unknown>): Record<string, unknown> & PeopleListSearch => ({
    ...search,
    email: typeof search.email === 'string' ? search.email : undefined,
    filters: typeof search.filters === 'string' ? search.filters : undefined,
    page: typeof search.page === 'number' ? search.page : undefined,
    source: typeof search.source === 'string' ? search.source : undefined,
  }),
});
